import { OfflineDatabaseProductColorPriceInfo } from '../../database/offlineDatabase/types/offlineDatabaseProductColorPriceInfo.types';

export class OfflineSkuPriceHandler {
  static getPricesBySize(
    productColorPriceInfo: OfflineDatabaseProductColorPriceInfo,
    sizeId: string,
  ) {
    const priceToSize =
      productColorPriceInfo.pricesToSizes.find((price) => price.sizeId === sizeId) ||
      productColorPriceInfo.pricesToSizes[0];

    const unitPrice =
      priceToSize.promotionalPrice !== undefined &&
      priceToSize.promotionalPrice < priceToSize.wholesalePrice
        ? priceToSize.promotionalPrice
        : priceToSize.wholesalePrice;

    return {
      unitPrice,
      retailPrice: priceToSize.retailPrice,
      wholesalePrice: priceToSize.wholesalePrice,
      promotionalPrice: priceToSize.promotionalPrice,
      priceComposition: priceToSize.priceComposition,
    };
  }
}
